var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbp-tabs",class:[
    'bbp-tabs',
    _vm.isSmall && 'bbp-tabs_small'
  ]},[_vm._l((_vm.tabsList),function(tab){return [_c('div',{key:tab.id,staticClass:"bbp-tabs__item",class:{'bbp-tabs__item_active' : _vm.activeTab === tab.id},on:{"click":function($event){return _vm.setActiveTab(tab)}}},[_vm._v("\n      "+_vm._s(tab.title)+"\n    ")])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82ef8d2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPTabs/BBPTabs.vue
// module id = null
// module chunks = 